import React, { Component } from 'react';
import { connect } from 'react-redux';
import { userActions } from '../../_actions';
import toast from '../shared/Toast';
import SettingsPageLayout from './SettingsPageLayout';
import './SettingsModern.css';

class EditPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      errors: {},
      saving: false,
      showOld: false,
      showNew: false,
      showConfirm: false,
    };
  }

  handleChange = (field, value) => {
    this.setState({ [field]: value, errors: {} });
  }

  validate = () => {
    const { oldPassword, newPassword, confirmPassword } = this.state;
    const errors = {};

    if (!oldPassword) errors.oldPassword = 'Current password is required';
    else if (oldPassword.length < 6) errors.oldPassword = 'Must be at least 6 characters';

    if (!newPassword) errors.newPassword = 'New password is required';
    else if (newPassword.length < 6) errors.newPassword = 'Must be at least 6 characters';

    if (!confirmPassword) errors.confirmPassword = 'Please confirm your new password';
    else if (newPassword !== confirmPassword) errors.confirmPassword = 'Passwords do not match';

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  }

  handleSubmit = () => {
    if (!this.validate()) return;

    this.setState({ saving: true });
    this.props.dispatch(userActions.changePassword({
      oldPassword: this.state.oldPassword,
      newPassword: this.state.newPassword,
    }))
      .then(response => {
        this.setState({ saving: false });
        if (response.data?.errorCode) {
          this.setState({ errors: { oldPassword: response.data.messages || 'Incorrect password' } });
        } else {
          toast.success('Password updated successfully');
          this.setState({ oldPassword: '', newPassword: '', confirmPassword: '' });
          this.props.history.push('/settings/account-password');
        }
      })
      .catch(() => {
        this.setState({ saving: false });
        toast.error('Something went wrong');
      });
  }

  render() {
    const { oldPassword, newPassword, confirmPassword, errors, saving, showOld, showNew, showConfirm } = this.state;

    const EyeIcon = ({ show, onClick }) => (
      <button type="button" className="ep-eye-btn" onClick={onClick}>
        {show ? (
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M1.5 9C1.5 9 4 3.5 9 3.5C14 3.5 16.5 9 16.5 9C16.5 9 14 14.5 9 14.5C4 14.5 1.5 9 1.5 9Z" stroke="currentColor" strokeWidth="1.3"/>
            <circle cx="9" cy="9" r="2.5" stroke="currentColor" strokeWidth="1.3"/>
          </svg>
        ) : (
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M1.5 9C1.5 9 4 3.5 9 3.5C14 3.5 16.5 9 16.5 9C16.5 9 14 14.5 9 14.5C4 14.5 1.5 9 1.5 9Z" stroke="currentColor" strokeWidth="1.3"/>
            <circle cx="9" cy="9" r="2.5" stroke="currentColor" strokeWidth="1.3"/>
            <path d="M3 15L15 3" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
          </svg>
        )}
      </button>
    );

    return (
      <SettingsPageLayout activeTab="account-password" {...this.props}>
        <div className="ep-container">
          <div className="ep-card">
            {/* Header */}
            <div className="ep-header">
              <div className="ep-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect x="3" y="11" width="18" height="11" rx="2" stroke="currentColor" strokeWidth="1.5"/>
                  <path d="M7 11V7C7 4.24 9.24 2 12 2C14.76 2 17 4.24 17 7V11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                  <circle cx="12" cy="16.5" r="1.5" fill="currentColor"/>
                </svg>
              </div>
              <h2 className="ep-title">Change Password</h2>
              <p className="ep-subtitle">Keep your account secure with a strong password</p>
            </div>

            {/* Form */}
            <div className="ep-form">
              <div className="ep-field">
                <label className="ep-label">Current Password</label>
                <div className="ep-input-wrap">
                  <input
                    type={showOld ? 'text' : 'password'}
                    className={`ep-input ${errors.oldPassword ? 'ep-input--error' : ''}`}
                    value={oldPassword}
                    onChange={(e) => this.handleChange('oldPassword', e.target.value)}
                    placeholder="Enter current password"
                  />
                  <EyeIcon show={showOld} onClick={() => this.setState(p => ({ showOld: !p.showOld }))} />
                </div>
                {errors.oldPassword && <span className="ep-error">{errors.oldPassword}</span>}
              </div>

              <div className="ep-field">
                <label className="ep-label">New Password</label>
                <div className="ep-input-wrap">
                  <input
                    type={showNew ? 'text' : 'password'}
                    className={`ep-input ${errors.newPassword ? 'ep-input--error' : ''}`}
                    value={newPassword}
                    onChange={(e) => this.handleChange('newPassword', e.target.value)}
                    placeholder="Enter new password"
                  />
                  <EyeIcon show={showNew} onClick={() => this.setState(p => ({ showNew: !p.showNew }))} />
                </div>
                {errors.newPassword && <span className="ep-error">{errors.newPassword}</span>}
              </div>

              <div className="ep-field">
                <label className="ep-label">Confirm New Password</label>
                <div className="ep-input-wrap">
                  <input
                    type={showConfirm ? 'text' : 'password'}
                    className={`ep-input ${errors.confirmPassword ? 'ep-input--error' : ''}`}
                    value={confirmPassword}
                    onChange={(e) => this.handleChange('confirmPassword', e.target.value)}
                    placeholder="Confirm new password"
                  />
                  <EyeIcon show={showConfirm} onClick={() => this.setState(p => ({ showConfirm: !p.showConfirm }))} />
                </div>
                {errors.confirmPassword && <span className="ep-error">{errors.confirmPassword}</span>}
              </div>
            </div>

            {/* Actions */}
            <div className="ep-actions">
              <button className="ep-btn ep-btn--secondary" onClick={() => this.props.history.push('/settings/account-password')}>
                Cancel
              </button>
              <button className="ep-btn ep-btn--primary" onClick={this.handleSubmit} disabled={saving}>
                {saving ? 'Saving...' : 'Update Password'}
              </button>
            </div>
          </div>
        </div>
      </SettingsPageLayout>
    );
  }
}

function mapStateToProps(state) {
  return { ...state };
}

export default connect(mapStateToProps)(EditPassword);
